import styled from "styled-components";
import { Link } from "react-router-dom";

export const HeaderSection = styled("header")`
  position: sticky;
  top: 0;
  z-index: 50;
  padding: 1rem 0 0;
`;

export const HeaderShell = styled("div")`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 1rem;
  padding: 0.9rem 1rem;
  border-radius: 999px;
  background: rgba(255, 255, 255, 0.72);
  border: 1px solid rgba(255, 255, 255, 0.78);
  box-shadow: 0 18px 44px rgba(31, 23, 64, 0.12);
  backdrop-filter: blur(18px);
`;

export const LogoContainer = styled(Link)`
  display: inline-flex;
  align-items: center;
  flex-shrink: 0;
`;

export const BrandMark = styled("img")`
  width: 122px;
  height: auto;
  object-fit: contain;
`;

export const DesktopNav = styled("nav")`
  display: flex;
  align-items: center;
  gap: 0.35rem;

  @media (max-width: 920px) {
    display: none;
  }
`;

export const NavButton = styled("button")`
  appearance: none;
  border: 0;
  background: transparent;
  color: var(--text-strong);
  padding: 0.8rem 1rem;
  border-radius: 999px;
  font-size: 0.95rem;
  font-weight: 700;
  cursor: pointer;
  transition: background 0.2s ease, color 0.2s ease, transform 0.2s ease;

  &:hover,
  &:focus-visible {
    background: rgba(225, 87, 148, 0.1);
    color: var(--primary);
    transform: translateY(-1px);
  }
`;

export const CTAWrapper = styled("div")`
  display: flex;
  align-items: center;
  gap: 0.65rem;

  @media (max-width: 920px) {
    display: none;
  }
`;

export const MobileToggle = styled("button")<{ open: boolean }>`
  appearance: none;
  display: none;
  border: 0;
  width: 52px;
  height: 52px;
  border-radius: 50%;
  background: rgba(225, 87, 148, 0.1);
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: background 0.2s ease;

  @media (max-width: 920px) {
    display: inline-flex;
  }

  &:hover,
  &:focus-visible {
    background: rgba(225, 87, 148, 0.16);
  }

  span {
    display: block;
    width: 22px;
    height: 2px;
    border-radius: 999px;
    background: var(--text-strong);
    transition: transform 0.2s ease, opacity 0.2s ease;
  }

  span + span {
    margin-top: 5px;
  }

  span:nth-child(1) {
    transform: ${({ open }) => (open ? "translateY(7px) rotate(45deg)" : "none")};
  }

  span:nth-child(2) {
    opacity: ${({ open }) => (open ? 0 : 1)};
  }

  span:nth-child(3) {
    transform: ${({ open }) => (open ? "translateY(-7px) rotate(-45deg)" : "none")};
  }
`;

export const MobilePanel = styled("div")<{ open: boolean }>`
  display: none;

  @media (max-width: 920px) {
    display: ${({ open }) => (open ? "grid" : "none")};
    gap: 0.85rem;
    margin-top: 0.9rem;
    padding: 1rem;
    border-radius: 28px;
    background: rgba(255, 255, 255, 0.92);
    border: 1px solid rgba(31, 23, 64, 0.08);
    box-shadow: var(--shadow-soft);
  }
`;

export const MobileNav = styled("nav")`
  display: grid;
  gap: 0.4rem;
`;

export const MobileAction = styled("div")`
  display: flex;
  justify-content: flex-start;

  button {
    max-width: 100%;
  }
`;
